export default __webpack_public_path__ + "static/media/sprite.418adb5b.svg";